import type { TFunction } from 'i18next';
import i18n from '../i18n/i18n';
import { TUTORIAL_STEP_LAYOUT } from './stepLayout';
import type { TutorialStep } from './steps';

export function buildTutorialSteps(t: TFunction): TutorialStep[] {
  return TUTORIAL_STEP_LAYOUT.map((meta) => {
    const base = `tutorial.platform.steps.${meta.id}`;
    const step: TutorialStep = {
      id: meta.id,
      title: t(`${base}.title`),
      body: t(`${base}.body`),
      route: meta.route,
      highlightSelector: meta.highlightSelector,
      gateType: meta.gateType,
    };
    if (meta.highlightSelectors) step.highlightSelectors = meta.highlightSelectors;
    if (meta.position) step.position = meta.position;
    if (meta.gateKey) step.gateKey = meta.gateKey;
    if (meta.minValue !== undefined) step.minValue = meta.minValue;
    if (meta.skipNavigateOnEnter) step.skipNavigateOnEnter = true;
    if (meta.popupAnchorSelector) step.popupAnchorSelector = meta.popupAnchorSelector;
    if (meta.hasTip) {
      const tip = t(`${base}.tip`, { defaultValue: '' });
      if (tip) step.tip = tip;
    }
    return step;
  });
}

/** Default steps using the active i18n language (for non-React callers). */
export function getTutorialSteps(): TutorialStep[] {
  return buildTutorialSteps(i18n.t.bind(i18n));
}
